var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7371 9.14289C8.92056 9.14289 9.87995 8.1835 9.87995 7.00004C9.87995 5.81657 8.92056 4.85718 7.7371 4.85718C6.55363 4.85718 5.59424 5.81657 5.59424 7.00004C5.59424 8.1835 6.55363 9.14289 7.7371 9.14289Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.7371 9.14289C8.92056 9.14289 9.87995 8.1835 9.87995 7.00004C9.87995 5.81657 8.92056 4.85718 7.7371 4.85718C6.55363 4.85718 5.59424 5.81657 5.59424 7.00004C5.59424 8.1835 6.55363 9.14289 7.7371 9.14289Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.16595 0.571533C4.51709 0.571533 0.45166 4.04116 0.45166 7.0001C0.45166 9.82387 4.51709 13.4287 8.16595 13.4287C12.0231 13.4287 15.8802 9.98158 15.8802 7.0001C15.8802 4.13128 11.8148 0.571533 8.16595 0.571533ZM8.16595 10.267C7.50225 10.267 6.85346 10.0754 6.30161 9.7164C5.74977 9.35743 5.31966 8.84722 5.06567 8.25028C4.81168 7.65334 4.74523 6.99648 4.87471 6.36277C5.00419 5.72906 5.32379 5.14697 5.7931 4.69009C6.2624 4.23321 6.86033 3.92207 7.51128 3.79602C8.16222 3.66997 8.83695 3.73466 9.45012 3.98192C10.0633 4.22918 10.5874 4.6479 10.9561 5.18514C11.3249 5.72237 11.5217 6.35398 11.5217 7.0001C11.5217 7.86653 11.1681 8.69747 10.5388 9.31012C9.90948 9.92277 9.05594 10.267 8.16595 10.267Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.12d72c2257ebb88ea605fa7021ef9b8a.svg";
export { ForwardRef as ReactComponent };